import { SchemaRecord } from "../SchemaRecord.js";

export class GroupsListParams extends SchemaRecord {
  static type = "chat.params.groups_list";
  static schema = {};
}
